export const leftMenuItems = [
  { as: 'a', content: 'Home', key: 'home', href: '/', icon: 'home' },
  // {
  //   text: 'Languages',
  //   key: 'languages',
  //   icon: 'flag outline',
  //   content: [
  //     {
  //       as: 'a',
  //       content: 'English',
  //       key: 'english',
  //       href: '/resources/English',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Mandarin Chinese',
  //       key: 'mandarin',
  //       href: '/resources/Mandarin Chinese',
  //     },

  //     {
  //       as: 'a',
  //       content: 'French',
  //       key: 'french',
  //       href: '/resources/French',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Spanish',
  //       key: 'spanish',
  //       href: '/resources/Spanish',
  //     },

  //     {
  //       as: 'a',
  //       content: 'Portuguese',
  //       key: 'portuguese',
  //       href: '/resources/Portuguese',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Japanese',
  //       key: 'japanese',
  //       href: '/resources/Japanese',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Korean',
  //       key: 'korean',
  //       href: '/resources/Korean',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Arabic',
  //       key: 'arabic',
  //       href: '/resources/Arabic',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Hindi',
  //       key: 'hindi',
  //       href: '/resources/Hindi',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Italian',
  //       key: 'italian',
  //       href: '/resources/Italian',
  //     },
  //     {
  //       as: 'a',
  //       content: 'Russian',
  //       key: 'russian',
  //       href: '/resources/Russian',
  //     },
  //   ],
  // },
  {
    as: 'a',
    content: 'Search The Library',
    key: 'search',
    href: '/search',
    icon: 'search',
  },
];

/* No longer required. */
export const rightMenuItems = [
  { as: 'a', content: 'Login', key: 'login' },
  { as: 'a', content: 'Register', key: 'register' },
];
